module.exports = __webpack_public_path__ + "img/하이어쌔신 (2).fe7f41aa.png";